export default function Backlog() {
  return null;
}

export const backlogSlug = "backlog";
